"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = versionUpdate;
var v2_0_0_1 = require("./v2_0_0");
function versionUpdate(story) {
    story = (0, v2_0_0_1.default)(story);
    return story;
}
//# sourceMappingURL=index.js.map